import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ReportesService } from '../../../services/reportes.service';

@Component({
  selector: 'app-recuperar-cliente-datacredito',
  templateUrl: './recuperar-cliente-datacredito.component.html',
  styleUrls: ['./recuperar-cliente-datacredito.component.css']
})
export class RecuperarClienteDatacreditoComponent implements OnInit {
  clientes = [];
  loading = false;
  constructor(public activeModal: NgbActiveModal, private reporteService: ReportesService) { }

  ngOnInit() {
    this.initClientes();
  }

  private initClientes() {
    this.reporteService.clientesExcluidosDatacredito()
    .subscribe((res: any) => this.clientes = res);
  }


  recuperar(item, i) {
    this.loading = true;
    this.reporteService.recuperarClientesDatacredito([item])
    .subscribe(() => {
      this.clientes.splice(i, 1);
      this.loading = false;
    });
  }

  recuperarTodos() {
    this.loading = true;
    this.reporteService.recuperarClientesDatacredito(this.clientes)
    .subscribe(() => {
      this.clientes = [];
      this.loading = false;
    });
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/modals/recuperar-cliente-datacredito/recuperar-cliente-datacredito.component.ts